export const getLocalStorageKey = (name: string): string => {
  if (process.env.APP_ENV === 'prod') return `leverup/${name}`;

  return `leverup.${process.env.APP_ENV}/${name}`;
};
